export default __webpack_public_path__ + "static/media/flag-bolivia-(plurinational-state-of).9a65ab6d.svg";